import RequireAuthorization from "../components/Authorization"
import Home from "../pages/Home"
import Operator from "../pages/Operator"
import RootLayout from "../layouts/main/RootLayout"
import Unauthorization from "../pages/UnAuthorization"
import FirmwareUpgrade from "../pages/FirmwareUpgrade"
import ConnectedDevice from "../pages/ConnectedDevice"
import DeviceSetting from "../pages/DeviceSetting"

const OperatorRouters = {
  path: "/",
  element: <RootLayout />,
  children: [
    {
      element: <RequireAuthorization role={"operator"} key={"auth"} />,
      children: [
        {
          path: "",
          element: <Home />,
        },
        {
          path: "operator",
          element: <Operator />,
          children: [
            {
              path: "upgrade",
              element: <FirmwareUpgrade />,
            },
            // {
            //   path: "connected-devices",
            //   element: <ConnectedDevice />,
            // },
            // {
            //   path: "connected-devices/:client_id/setting",
            //   element: <DeviceSetting />,
            // },
          ],
        },
        {
          path: "unauthorized",
          element: <Unauthorization />,
        },
      ],
    },
  ],
}

export default OperatorRouters
